import { useEffect, useState } from 'react';

// Material UI
import { Grid, Button, Container } from '@mui/material';
import { Add } from '@mui/icons-material';

import Swal from 'sweetalert2';

// Componentes
import AdminLayout from '@components/MainPage/AdminLayout';
import ActionHeader from '@components/Containers/ActionHeader';
import LoadingForm from '@components/LinearProgress/LoadingForm';

//SERVICES
import events from '@services/EventsServices';

//UTILS
import { convertBase64 } from '@utils/Utilities';

//MIDDLEWARE
import middleware from '@middlewares/middleware';
import FormTemplateQR from '@components/Events/FormTemplateQR';
import TableTemplate from '@components/Events/TableTemplate';

const TemplatesQR = ({ idTipo }) => {
  const [openModal, setOpenModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [refreshApi, setRefreshApi] = useState(false);
  const hasAddPermission = middleware.checkMenuAction('Agregar');
  const titleModal = 'Registrar de Plantillas';

  useEffect(() => {
    setRefreshApi((prev) => !prev);
  }, [idTipo]);

  const handleInsertData = async (values) => {
    try {
      setLoading(true);

      const file = values.files[0].file;

      if (file && file instanceof File) {
        const base64File = await convertBase64(file);
        values.files[0].file = base64File;
      }

      const result = await events.setTemplate(values);
      const { results, message } = result;
      if (results) {
        setRefreshApi((prev) => !prev);
        Swal.fire({
          title: message,
          icon: 'success',
          customClass: {
            container: 'modal-alert',
          },
        });
        setOpenModal(false);
      } else {
        throw new Error(message);
      }
    } catch (error) {
      Swal.fire({
        title: error.message,
        icon: 'warning',
        customClass: {
          container: 'modal-alert',
        },
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <AdminLayout>
      <Container maxWidth={false}>
        <ActionHeader title={'Gestión de Registros de Plantillas'} isCustom={true}>
          {hasAddPermission ? (
            <Button
              variant="contained"
              color="primaryDark"
              size="small"
              endIcon={<Add />}
              onClick={() => setOpenModal(true)}
            >
              Agregar Nuevo
            </Button>
          ) : null}
        </ActionHeader>
        <LoadingForm
          isLoading={loading}
          isOpen={loading}
          setIsOpen={() => setLoading(!loading)}
          loadinMessage={'Cargando...'}
        />
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <TableTemplate idTipo={idTipo} setIsLoading={(e) => setLoading(e)} refresh={refreshApi} />
          </Grid>
        </Grid>
        {openModal && (
          <FormTemplateQR
            setModalOpen={setOpenModal}
            modalOpen={openModal}
            title={titleModal}
            idTipo={idTipo}
            setData={handleInsertData}
          />
        )}
      </Container>
    </AdminLayout>
  );
};

export default TemplatesQR;
